import React from 'react';

import {
  isProd,
  StoreThemeProvider
} from 'modules/layer00';
import {
  AppBar,
  Box,
  IconButton,
  styled,
  Toolbar as MuiToolbar
} from '@mui/material';

import { TestModeWarningBar } from 'iron-forge-react-modules';
import { useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import * as dataService from './dataService';



const Toolbar = styled(MuiToolbar)(({ theme }) => ({
  backgroundColor: 'white',
  gap: theme.spacing(1)
}));

const LogoImg = styled('img')({
  maxHeight: 30
});

const RootBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(2)
}));



export interface IProps {
  storeId: string;
  children: React.ReactNode;
}

export const FC: React.FC<IProps> = props => {
  const tuple = dataService.useQuery(props.storeId);
  const navigate = useNavigate();



  function handleClickBack() {
    navigate(-1);
  }



  return (
    <>
      {!isProd && (
        <TestModeWarningBar.FC />
      )}

      <StoreThemeProvider.FC storeId={props.storeId}>
        <AppBar position="relative">
          <Toolbar>
            <IconButton onClick={handleClickBack}>
              <ArrowBack />
            </IconButton>

            <LogoImg src={tuple.data.logoUrl} />
          </Toolbar>
        </AppBar>

        <RootBox>
          {props.children}
        </RootBox>
      </StoreThemeProvider.FC>
    </>
  );
};
